
export default {
  name: 'OrganismTitleAndDescription',
  props: {
    visionData: {
      required: true,
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
